<template>
  <!--发起的签署-->
  <div class="apply-list">
    <el-row type="flex" class="row" justify="end">
      <el-col :span="signStatusSet !== '-2' ? 5 : 9"></el-col>
      <el-col :span="7" style="margin-right: 15px">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-select v-model="selectParam" placeholder="请选择" size="small">
              <el-option label="文件名称" value="contractName" />
              <!--<el-option label="文件编号" value="applyNo"/>-->
              <el-option label="签署方" value="signatoryFullName" />
              <!--<el-option label="手机号" value="signatoryMobile"/>-->
              <!--<el-option label="证件号" value="signatoryIdentityCard"/>-->
            </el-select>
          </el-col>
          <el-col :span="12">
            <el-input v-model="selectParamVal" size="small" placeholder="查询内容" />
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="4" v-if="+$route.query.signStatus === 3">
        <div style="text-align: center; white-space: nowrap">
          <el-select style="width: 140px" v-model="selectedStatus" placeholder="请选择" size="small">
            <el-option
              v-for="(item, index) in statusEnum"
              :label="item.label"
              :key="'status' + index"
              :value="item.value"
              v-show="!['0', '-3'].includes(item.value)"
            />
          </el-select>
        </div>
      </el-col>
      <el-col :span="5">
        <el-row>
          <el-date-picker
            v-model="paramDateArr"
            type="daterange"
            value-format="yyyy-MM-dd"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            style="width: 100%"
          />
        </el-row>
      </el-col>
      <el-col :span="3" class="text-right">
        <el-row type="flex">
          <el-col :span="12">
            <el-button @click="queryFilter" size="small">查询</el-button>
          </el-col>
          <el-col :span="12">
            <el-button @click="rest" size="small">重置</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <!--草稿箱-->
    <el-table
      style="min-height: 54vh"
      class="data-list"
      v-if="signStatusSet === '-2'"
      :data="tableList"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      ref="dataList"
      :header-cell-style="{
        background: '#f9f9f9',
        color: '#333333',
        fontWeight: '500',
      }"
      key="type6"
    >
      <el-table-column type="selection" width="45" />
      <el-table-column label width="90">
        <template slot-scope="scope">
          <el-button v-if="scope.row.coEditingId" size="mini" type="primary">继续编辑</el-button>
        </template>
      </el-table-column>
      <el-table-column label="文件名称" prop="contractName">
        <template slot-scope="scope">
          <div style="position: relative; padding-top: 10px">
            <!--<span class="multiFile" v-if="scope.row.files > 1">多</span>-->
            <span class="multiFile" v-if="scope.row.multiFile">多</span>
            <template v-if="!isInDingTalk">
              <div
                class="custom-link textEllipsis"
                style="margin-right: 5px; opacity: 1"
                target="_blank"
                @click="toDetails(scope.row)"
              >
                <el-tooltip
                  effect="dark"
                  :content="scope.row.contractName"
                  placement="bottom-start"
                >
                  <span style="font-size: 16px">
                    {{
                    scope.row.contractName
                    }}
                  </span>
                </el-tooltip>
              </div>
            </template>
            <template v-else>
              <span class="custom-link textEllipsis" style="margin-right: 5px; opacity: 1">
                <el-tooltip
                  effect="dark"
                  :content="scope.row.contractName"
                  placement="bottom-start"
                >
                  <span style="font-size: 16px" @click="dingTurn(scope.row)">
                    {{
                    scope.row.contractName
                    }}
                  </span>
                </el-tooltip>
              </span>
            </template>
          </div>
          <p class="textEllipsis">创建人：{{ scope.row.ebqUserName }}</p>
          <p class="textEllipsis">创建时间：{{ scope.row.createTime | formatDateHM }}</p>
        </template>
      </el-table-column>
      <!--      <el-table-column label="签署方" prop="allSignerName" show-overflow-tooltip/>-->
      <el-table-column label="签署方" width="300">
        <template slot-scope="scope">
          <el-tooltip placement="bottom-start">
            <div
              slot="content"
              v-for="(item, index) in scope.row.signInfoVOS"
              style="display: flex; align-items: center; padding-bottom: 5px"
              :key="index"
            >
              <span
                v-if="item.orderNum && item.orderNum >= 1"
                style="
                  display: block;
                  width: 13px;
                  height: 13px;
                  border-radius: 50%;
                  color: #ffffff;
                  border: 1px solid #ffffff;
                  text-align: center;
                  line-height: 13px;
                  font-size: 12px;
                "
              >{{ item.orderNum }}</span>
              <span v-else style="color: #ffffff">·</span>
              <p style="color: #ffffff; font-size: 12px">&nbsp;{{ item.signatoryFullName }}</p>
            </div>
            <div>
              <p class="textEllipsis">
                {{
                scope.row.signInfoVOS[0]
                ? scope.row.signInfoVOS[0].signatoryFullName
                : ""
                }}
              </p>
              <p
                class="textEllipsis"
                v-if="scope.row.signInfoVOS.length > 1"
              >{{scope.row.signInfoVOS[1].signatoryFullName}}</p>
              <template>
                <p
                  class="textEllipsis"
                  v-if="(scope.row.signInfoVOS.length === 3)"
                >{{ scope.row.signInfoVOS[2].signatoryFullName }}</p>
                <p class="textEllipsis" v-if="(scope.row.signInfoVOS.length > 3)">···</p>
              </template>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <!--      <el-table-column label="创建时间" prop="createTime">-->
      <!--        <template slot-scope="scope" v-if="scope.row && scope.row.createTime">{{scope.row.createTime | formatDateHM}}-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <el-table-column label="创建时间" prop="createTime" width="180">
        <template slot-scope="scope" v-if="scope.row && scope.row.updateTime">
          <span style="color: rgba(41, 2, 2, 0.65)">
            {{
            scope.row.updateTime | formatDateHM
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope" v-if="!(scope.row.applyNo && scope.row.applyNo.startsWith('APLO'))">
          <template v-if="scope.row.coEditingId">
            <span
              @click="
                turnOffice({
                  path: '/initiation/toCreate',
                  query: {
                    drafts: 1,
                    draftCoEditingSec: scope.row.coEditingId,
                  },
                })
              "
              class="color-success edit pointer"
              style="margin-right: 5px"
            >编辑</span>
            <!-- target="_blank" -->
          </template>
          <template v-else>
            <span
              @click="dingEdit(scope.row)"
              class="color-success edit pointer"
              style="margin-right: 5px"
            >编辑</span>
          </template>
        </template>
      </el-table-column>
      <no-data text="暂无数据" slot="empty" />
    </el-table>

    <!--非草稿箱-->
    <el-table
      style="min-height: 54vh"
      v-else
      class="data-list"
      :data="tableList"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      ref="dataList"
      v-loading="loading"
      :expand-row-keys="expandKeys"
      :row-key="
        (row) => {
          return row.applyId;
        }
      "
      @cell-mouse-enter="cellMouseEnter"
      @cell-mouse-leave="cellMouseLeave"
      :header-cell-style="{
        background: '#f9f9f9',
        color: '#333333',
        fontWeight: '500',
      }"
      key="typeOther"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column label="文件名称">
        <template slot-scope="scope">
          <div
            style="
              display: flex;
              align-items: center;
              position: relative;
              padding-top: 10px;
            "
          >
            <span class="multiFile" v-if="scope.row.files > 1">多</span>
            <apply-name
              applyType="applyList"
              :signInfo="{
                status: scope.row.signStatus,
                signNo: scope.row.signNo,
                applyNo: scope.row.applyNo,
                name: scope.row.contractName,
                row: scope.row,
                selfSign: scope.row.selfSign,
                multiFile: scope.row.multiFile,
              }"
            ></apply-name>
          </div>

          <p class="textEllipsis">发起方：{{ scope.row.ebqUserName }}</p>
          <p class="textEllipsis">发起时间：{{ scope.row.createTime | formatDateHM }}</p>
        </template>
      </el-table-column>
      <!--      <el-table-column label="备案号">-->
      <!--        <template slot-scope="scope">-->
      <!--          <span v-if="scope.row.vpresId">-->
      <!--            {{ scope.row.vpresId }}-->
      <!--          </span>-->
      <!--          <span v-else>——</span>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <el-table-column label="签署方">
        <template slot-scope="scope">
          <el-tooltip placement="bottom-start">
            <div
              slot="content"
              v-for="(item, index) in scope.row.signInfoVOS"
              :key="index"
              style="display: flex; align-items: center; padding-bottom: 5px"
            >
              <span
                v-if="item.orderNum && item.orderNum >= 1"
                style="
                  display: block;
                  width: 13px;
                  height: 13px;
                  border-radius: 50%;
                  color: #ffffff;
                  border: 1px solid #ffffff;
                  text-align: center;
                  line-height: 13px;
                  font-size: 12px;
                "
              >{{ item.orderNum }}</span>
              <span v-else style="color: #ffffff">·</span>
              <div style="color: #ffffff; font-size: 12px">
                【{{
                item.signStatus === 0 || item.signStatus === -1
                ? "未签署"
                : item.signStatus === 1
                ? "已签署"
                : "已拒签"
                }}】
              </div>
              <p style="color: #ffffff; font-size: 12px">{{ item.signatoryFullName || "" }}</p>
            </div>
            <div>
              <p class="textEllipsis">
                {{
                scope.row.signInfoVOS[0]
                ? scope.row.signInfoVOS[0].signatoryFullName
                : ""
                }}
              </p>
              <p
                class="textEllipsis"
                v-if="scope.row.signInfoVOS.length > 1"
              >{{scope.row.signInfoVOS[1].signatoryFullName}}</p>
              <template>
                <p
                  class="textEllipsis"
                  v-if="(scope.row.signInfoVOS.length === 3)"
                >{{ scope.row.signInfoVOS[2].signatoryFullName }}</p>
                <p class="textEllipsis" v-if="(scope.row.signInfoVOS.length > 3)">···</p>
              </template>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100">
        <template slot-scope="scope">
          <template v-if="scope.row.signStatus === 0">
            <span v-if="scope.row.selfSign === 1" class="red">待我签</span>
            <span v-else class="blue">待ta签</span>
          </template>
          <span v-else-if="scope.row.signStatus === 1" class="green">已完成</span>
          <span v-else-if="scope.row.signStatus === 2" class="orange">已拒签</span>
          <span v-else-if="scope.row.signStatus === -3" class="blue">待审核</span>
          <span v-else-if="scope.row.signStatus === -5" class="grey">已撤销</span>
          <span v-else-if="scope.row.signStatus === -6" class="grey">已过期</span>
          <span v-else-if="scope.row.signStatus === 4" class="orange">已作废</span>
        </template>
      </el-table-column>
      <!--      <el-table-column label="发起时间" prop="createTime">-->
      <!--        <template slot-scope="scope">{{scope.row.createTime | formatDateHM}}</template>-->
      <!--      </el-table-column>-->
      <!-- <el-table-column type="expand" width="1">
        <template slot-scope="scope">
          <el-form inline class="demo-table-expand">
            <el-form-item>
              <more-button :rowData="scope.row" :showMoreBtn="true" @btnMethodFn="openLYDialog"></more-button>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>-->
      <el-table-column label="操作" width="130">
        <template slot-scope="scope" v-if="!(scope.row.applyNo && scope.row.applyNo.startsWith('APLO'))">
          <apply-handles
            v-if="scope.row.signStatus !== 1"
            applyType="applyList"
            fieldType="signStatus"
            :rowData="scope.row"
            @resetList="getSignLists"
          ></apply-handles>
          <!--          <div-->
          <!--            v-if="scope.row.signStatus === 1"-->
          <!--            @click="openLYDialog(scope.row)"-->
          <!--            class="com-normal-btn"-->
          <!--          >-->
          <!--            上传履约文件-->
          <!--          </div>-->

          <template v-if="scope.row.signStatus === 1">
            <!--            <span-->
            <!--              v-if="scope.row.vpresId"-->
            <!--              id="tag-copy"-->
            <!--              :data-clipboard-text="scope.row.vpresId"-->
            <!--              @click="copyTextToQuery(scope.row.vpresId)"-->
            <!--              class="com-normal-btn"-->
            <!--            >-->
            <!--                存证查询-->
            <!--              </span>-->
            <existing-evidence :rowData="scope.row" @copyTextToQueryEmit="copyTextToQuery"></existing-evidence>
            <!-- <div
              class="com-normal-btn"
              @click="moreBtnShowFn(scope.row)"
            >
              更多操作
            </div>-->
            <el-dropdown trigger="click" @visible-change="visiChange($event, scope.row.applyId)">
              <span class="com-normal-btn">
                更多操作
                <i
                  :class="
                    visiDown.status && visiDown.rowApplyId == scope.row.applyId
                      ? 'el-icon-caret-top'
                      : 'el-icon-caret-bottom'
                  "
                  class="com-normal-btn el-icon--right"
                ></i>
              </span>
              <el-dropdown-menu slot="dropdown" style="background-color: #f5f6f6">
                <more-button
                  :rowData="scope.row"
                  :showMoreBtn="true"
                  :Cancancel="true"
                  @btnMethodFn="openLYDialog"
                ></more-button>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <span
            class="com-normal-btn"
            v-if="
                  scope.row.applySignStatus === 4 || scope.row.signStatus === 4
                "
            @click="toApplyDetail(scope.row)"
          >查看作废协议</span>
        </template>
      </el-table-column>
      <no-data text="暂无数据" slot="empty" />
    </el-table>
    <div class="bulkOperation" v-if="batchLength && false">已选{{ batchLength }}份文件</div>
    <!--分页-->
    <el-row class="pageation row">
      <el-col :span="8">
        <el-button v-if="+$route.query.signStatus === 3" @click="batchDown" size="small">下载</el-button>
        <el-button size="mini" @click="emitFn('saveToDir')">归档</el-button>
        <!-- 历史文件移动到 收件箱里面 -->
        <el-button
          v-if="$route.query.match"
          @click="emitFn('toHistory')"
          v-show="
            $store.getters.currentAuthUser.userType == 1 &&
            $route.path.indexOf('signList') > -1
          "
          size="mini"
        >历史文件</el-button>
        <!-- 收件箱归档列表里面添加归档(移动)和物理删除按钮 -->
        <template v-if="currentPathDirType === 2 && $route.query.directoryId">
          <div>
            <!-- 新添加 -->
            <el-button @click="emitFn('dirMove')" size="small">归档</el-button>
            <el-button @click="emitFn('physicsDelete')" size="small">删除</el-button>
          </div>
        </template>
        <template v-if="currentPathDirType === 1">
          <div>
            <!-- 新添加 -->
            <el-button @click="emitFn('saveToDir')" size="small">归档</el-button>
            <el-button
              v-if="!$route.query.notMeSign && false"
              @click="removeFromDir()"
              size="small"
            >删除</el-button>
          </div>
        </template>
        <!-- 草稿箱添加删除按钮 -->
        <template v-if="$route.query.signStatus == '4'">
          <div>
            <el-button @click="emitFn('deleteFromDir')" size="small">删除</el-button>
          </div>
        </template>
      </el-col>
      <el-col :span="16" class="page-flex-end">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParam.itemPage"
          :pager-count="5"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="queryParam.pageSize"
          layout="sizes, prev, pager, next, total"
          :total="queryParam.total"
        />
        <el-go
          :page-size="queryParam.pageSize"
          :total="queryParam.total"
          @current-change="handleCurrentChange"
        ></el-go>
      </el-col>
    </el-row>
    <!-- 手写loading -->
    <div
      v-show="batchLoading"
      style="
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 1900;
      "
      v-loading="batchLoading"
      element-loading-text="合同发起中，请勿关闭当前页面"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.5)"
    ></div>
    <!--标签管理-->
    <tag-manage @close="getTagList" @refresh="getSignLists" ref="tagManage" />

    <!--履约文件-->
    <el-dialog title="履约文件" :visible.sync="lYDialogVisible" width="850px" class="ly-info">
      <el-tabs v-model="activeName" class="ly-mask" @tab-click="handleClick">
        <el-tab-pane label="上传原文件" name="1">
          <p class="tips">支持常见图片、文档、视频、音频、压缩包格式，上传后会保存原文件，单个文件大小不超过30MB</p>
          <div class="box-wrap">
            <div class="temone add">
              <span class="el-icon-plus"></span>
              <input ref="referenceUpload" type="file" class="file-ipt" @change="handleInputChange" />
            </div>

            <div class="temone" v-for="(item, idx) in lYDialogData" :key="idx">
              <div class="t-box">
                <img class="y-img" src="/images/web/file-icon.png" />
                <div class="msk">
                  <span class="des">上传人：{{ item.userName }} -{{ item.accountName }}</span>
                </div>
              </div>

              <div class="a-btn">
                <a class="has-hover" :href="downloadLYFile(item.file)">下载</a>
                <a v-if="isDoc(item)" class="has-hover" @click="previewDoc(item)">预览</a>
                <a v-if="isVideoOrImg(item)" class="has-hover" @click="previewVideOrImg(item)">预览</a>
                <a v-if="item.canDelete" class="has-hover" @click="delLYFile(item)">删除</a>
                <a class="no-hover">{{ item.fileName }}</a>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="上传文件哈希" name="2">
          <p class="tips">格式没有限制，仅保存上传文件的特征值（哈希），不对文件本身做保存，单个文件大小不超过500M</p>

          <div class="box-wrap">
            <div class="temone add">
              <span class="el-icon-plus"></span>
              <input
                ref="referenceUpload1"
                type="file"
                class="file-ipt"
                @change="handleInputChange"
              />
            </div>

            <div class="temone" v-for="(item, idx) in lYDialogData" :key="idx">
              <div class="t-box">
                <img class="y-img" src="/images/web/hash-icon.png" />
                <div class="msk">
                  <span class="des">上传人：{{ item.userName }} -{{ item.accountName }}</span>
                  <br />
                  <span class="des" style="margin: 0">备案号：{{ item.presId }}</span>
                </div>
              </div>

              <div class="a-btn">
                <a class="has-hover" @click="validLYFile(item)">验证</a>
                <a v-if="item.canDelete" class="has-hover" @click="delLYFile(item)">删除</a>
                <a class="no-hover">{{ item.fileName }}</a>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="footer">
        <span class="num">
          文件数：
          <label>{{ lYDialogData.length }}</label>个
        </span>
        <el-button
          type="primary"
          size="small"
          class="cancel-btn"
          @click="lYDialogVisible = false"
        >关闭</el-button>
      </div>
    </el-dialog>

    <!--pdf文件预览-->
    <ViewFilesToDoc
      :visibleShow="visibleShowEnclosureDoc"
      :enclosurePreviewNumItem="enclosurePreviewNumItem"
      @setViewFilesToDocDialogData="onSetViewFilesToDocDialogData"
    />
    <!--附件图片video预览显示-->
    <ViewFilesToImg
      :visibleShow="visibleShowEnclosure"
      :isRefresh="isRefresh"
      :enclosurePreviewNumItem="enclosurePreviewNumItem"
      :imgList="getEnclosureImgList"
      @setViewFilesToImgDialogData="onSetViewFilesToImgDialogData"
      style="text-align: center"
    />
    <!--  提示展示批量签署时提醒签章   -->
    <el-dialog
      :visible.sync="nodeQueryVisible"
      custom-class="data-dialog"
      width="800px"
      destroy-on-close
    >
      <div class="node_header" slot="title">保全链节点查询</div>
      <p style="padding: 10px">当前合同备案号：{{ vpresId }}</p>
      <node-query :vpresId="vpresId" />
    </el-dialog>
  </div>
</template>

<script>
import Bus from "@/plugins/bus.js";
import existingEvidence from "@/components/apply-list/existing-evidence";
import certiServicepopover from "@/components/apply-list/certiServicepopover";
import moreButton from "@/components/apply-list/more-button";
import {
  postApplyPage,
  postApplyBadge,
  applyViewUrl,
  ApiMethods,
  getFindFileDownload
} from "../../assets/js/http-serve/http-methods";
import ElGo from "../../components/go/Go";
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import ApplyHandles from "@/components/apply-list/handles";
import ApplyName from "@/components/apply-list/contractName";
import TagManage from "@/components/tag-manage";
import ViewFilesToDoc from "@/components/viewFiles/ViewFilesToDoc";
import ViewFilesToImg from "@/components/viewFiles/ViewFilesToImg";
import sha512Crypto from "js-sha512";
import Clipboard from "clipboard";
import nodeQuery from "@/components/signInfo/node-query";
import { isInDingTalk, authentication } from '@/assets/js/utils/ding-env';

export default {
  components: {
    existingEvidence,
    certiServicepopover,
    moreButton,
    ElGo,
    ApplyHandles,
    ApplyName,
    TagManage,
    ViewFilesToDoc,
    ViewFilesToImg,
    nodeQuery
  },
  props: ["showDirBtn", "currentPathDirType"],
  data () {
    return {
      isInDingTalk,
      visiDown: {
        status: false,
        rowApplyId: ""
      },
      expandKeys: [],
      getDTag: false,
      tagLists: [],
      // 批量签loading
      batchLoading: false,
      tableList: [],
      // 请求参数
      queryParam: {
        itemPage: 1,
        pageSize: 10,
        total: 0,
        dateType: null,
        beginDate: null,
        endDate: null,
        applyNo: null,
        contractName: null,
        signatoryFullName: null,
        signatoryMobile: null,
        signatoryIdentityCard: null,
        signStatusSet: null,
        createType: 1,
        newVersion: 1,
        showAll: 1
      },
      selectParam: "contractName",
      selectedStatus: "",
      selectParamVal: "",
      paramDateArr: null,
      directoryId: null,
      signStatusSet: null,
      signStatus: null,
      badge: 0,
      // 加载中显示
      loading: false,
      checkedList: [],
      batchLength: null,

      //履约文件数据
      lYDialogVisible: false, //履约文件弹窗
      lYDialogData: [], //履约文件列表
      activeName: "1", //1：文件上传，2：hash值上传
      visibleShowEnclosure: false,
      visibleShowEnclosureDoc: false,
      enclosurePreviewNumItem: {}, // 当前预览项
      isRefresh: true, // 预览附件时，强制刷新
      rowData: {},
      nodeQueryVisible: false, //节点查询
      vpresId: "" // 备案号传入节点查询组件
    };
  },
  beforeCreate () {
    if (this.$route.query.ccToMe || this.$route.query.match) {
      this.$router.replace({
        path: "/signInfo/signList",
        query: { signStatus: 2 }
      });
    }
    return false;
  },
  created () {
    let query = this.$route.query;
    this.signStatus = query ? ~~query.signStatus : null;
    this.directoryId = query ? query.directoryId : null;
    this.signStatusFn(this.signStatus);
    this.checkContractBatch();
    this.getTagList();
    //清除归档操作后的缓存
    Bus.$on('$saveToDirNewEndClear1', () => {
      this.$refs["dataList"].clearSelection();
      this.getSignLists();
    })
  },
  destroyed () {
    Bus.$off("$saveToDirNewEndClear1");
  },
  computed: {
    draftEdit () {
      return function (status) {
        return status ? "/initiation/toCreate" : "/applySign/toCreate";
      };
    },
    statusEnum () {
      return [
        {
          label: "全部",
          value: "-1"
        },
        // {
        //   label: "待审核",
        //   value: "-3"
        // },
        // {
        //   label: "待我签",
        //   value: "0"
        // },
        // {
        //   label: "待ta签",
        //   value: "1"
        // },
        {
          label: "已完成",
          value: "2"
        },
        {
          label: "已拒签",
          value: "3"
        },
        {
          label: "已过期",
          value: "4"
        },
        {
          label: "已撤销",
          value: "5"
        },
        {
          label: "已作废",
          value: "6"
        }
      ];
    },
    // 获取附件中的图片列表，用于预览
    getEnclosureImgList () {
      let a = this.lYDialogData.filter(item => {
        return this.isVideoOrImg(item);
      });
      return a;
    }
  },
  watch: {
    paramDateArr: {
      handler (val) {
        if (val && val.length === 2) {
          this.queryParam.beginDate = val[0];
          this.queryParam.endDate = val[1];
        } else {
          this.queryParam.beginDate = this.queryParam.endDate = null;
        }
      },
      deep: true
    },
    selectedStatus: function (val) {
      this.queryParam["selfSign"] = null;
      this.queryParam["signStatusSet"] = this.signStatusSet;
      switch (val) {
        case "-3":
          this.queryParam["signStatusSet"] = "-3";
          break;
        case "0":
          this.queryParam["signStatusSet"] = "0";
          this.queryParam["selfSign"] = 1;
          break;
        case "1":
          this.queryParam["signStatusSet"] = "0";
          this.queryParam["selfSign"] = 0;
          break;
        case "2":
          this.queryParam["signStatusSet"] = "1";
          break;
        case "3":
          this.queryParam["signStatusSet"] = "2";
          break;
        case "4":
          this.queryParam["signStatusSet"] = "-6";
          break;
        case "5":
          this.queryParam["signStatusSet"] = "-5";
          break;
        case "6":
          this.queryParam["signStatusSet"] = "4";
          break;
      }
    },
    selectParamVal: function (val) {
      this.queryParam[this.selectParam] = val;
    },
    selectParam: function (newVal, oldVal) {
      this.queryParam[newVal] = this.queryParam[oldVal];
      this.queryParam[oldVal] = null;
    },

    directoryId (val) {
      // this.queryParam["directoryId"] = val;
      // this.getSignLists();
    },
    $route: {
      handler () {
        this.resetScreenParams();
        let query = this.$route.query;
        this.signStatus = query ? ~~query.signStatus : 1;
        this.directoryId = query ? query.directoryId : null;
        this.signStatusFn(this.signStatus);
      },
      deep: true
    }
  },
  methods: {
    toDetails(row){
      // 判断是否国际版发起的合同，如果不是就提示去国内版本签署(当合同applyNo以APLO开头时，说明是国际版发起的合同)
      if((row.applyNo && row.applyNo.startsWith('APLO'))){
        return this.$message.warning('国际版发起的文件请前往 FairSigning 操作!');
      };
      if (row.coEditingId) {
        this.$router.push({
          path: '/initiation/collaborationEdit',
          query: {
            drafts: 1,
            draftCoEditingSec: row.coEditingId,
          },
        })
      } else {
        this.$router.push({
          // path: scope.row.multiFile ? '/initiation/toCreate' : '/applySign/toCreate',
          path: this.draftEdit(row.multiFile),
          query: { applyId: row.applyIdSec },
        })
      }
    },
    // 查看作废协议（合同作废发起使用的是pc多文件发起，默认走多文件查看页面）
    toApplyDetail (row) {
      if (row.applySignCreateType === 0 && row.applySignDealType === 6) {
        return this.$message.error('该合同仅是hash保全，无法查看合同内容');
      }
      let funLoading = null;
      if (this.$store.getters.authUser.identityAuth > -1) {
        let param = {
          signNo: row.signNo,
          applyNo: row.terminationApplyNo,
          multiFile: 1
        };
        funLoading = this.$loading({ lock: true });
        applyViewUrl(param)
          .then(url => {
            funLoading.close();
            isInDingTalk ? location.href = url : window.open(url);
          })
          .catch(err => {
            funLoading.close();
            this.$message.error(err.description || "无法查看该合同");
            console.error("toApplyDetail: " + JSON.stringify(err));
          });
      }
    },
    dingEdit (row) {
      const path = {
        path: row.multiFile ? '/initiation/toCreate' : '/applySign/toCreate',
        query: { applyId: row.applyIdSec },
      }
      const newPath = this.$router.resolve(path);
      isInDingTalk ? this.$router.push(path) : window.open(window.location.origin + newPath.href, "_blank")
    },
    dingTurn (row) {
      const path = {
        path: row.multiFile ? '/initiation/toCreate' : '/applySign/toCreate',
        query: { applyId: row.applyIdSec },
      }
      this.$router.push(path)
    },
    turnOffice (pathObj) {
      let routeUrl = this.$router.resolve(pathObj);
      isInDingTalk ? this.$router.push(pathObj) : window.open(routeUrl.href, "_blank");
    },
    // 删除文件
    removeFromDir () {
      this.$emit("removeFromDir");
    },
    batchDown () {
      let selection = this.$refs["dataList"].selection || [];
      if (!selection.length)
        return this.$confirm("请先选择需要下载的签署。", "系统提示", {
          showConfirmButton: true,
          showCancelButton: false
        });
      let arr = selection.map((item) => {
        return item.applyNo;
      });
      ApiMethods.UseEnterpriseController.downloadBatch({
        applyNos: arr.toString(),
      })
        .then(res => {
          if (!res.success) {
            return this.$message.error(res.description || this.$tip);
          }
          this.downloadFile(res.data);
        })
        .finally(() => (this.loading = false));
    },
    async downloadFile (param) {
      param.fix = ".zip";
      let res = await ApiMethods.FileOperController.download_get(param);
      if (res.success && res.url) {
        this.$refs["dataList"].clearSelection();
        window.location.href = res.url;
      } else {
        this.$message.error(res.err);
      }
    },
    emitFn (fn) {
      // this.$emit("emitFn", fn);
      let selection = this.$refs["dataList"].selection || [];
      //触发signInfo中的归档操作
      Bus.$emit("$saveToDirNew1", {
        selection: selection,
      })
    },
    //NO3
    signStatusSetFn (val) {
      this.queryParam = {
        itemPage: 1,
        pageSize: 10,
        total: 0,
        dateType: null,
        beginDate: null,
        endDate: null,
        applyNo: null,
        contractName: null,
        signatoryFullName: null,
        signatoryMobile: null,
        signatoryIdentityCard: null,
        directoryId: this.directoryId,
        signStatusSet: val,
        createType: 1,
        newVersion: 1,
        showAll: 1
      };
      this.getSignLists();
    },
    //NO2
    signStatusFn (val) {
      this.selectedStatus = "";
      this.queryParam.selfSign = null;
      switch (val) {
        case 1: // 全部
          this.signStatusSet = "";
          break;
        case 2: // 未完成
          this.signStatusSet = "0";
          break;
        case 3: // 已结束
          this.signStatusSet = "1,2,4,-5,-6";
          break;
        case 4: // 草稿箱
          this.signStatusSet = "-2";
          break;
        default:
          this.signStatusSet = "";
          break;
      }
      this.signStatusSetFn(this.signStatusSet);
      this.addConditionFn(); //追加条件
    },

    visiChange (val, rowApplyId) {
      this.visiDown = {
        status: val,
        rowApplyId
      };
    },
    //更多按钮展开
    moreBtnShowFn (obj) {
      if (this.expandKeys[0] === obj.applyId) {
        this.expandKeys = [];
      } else {
        this.expandKeys = [obj.applyId];
      }
    },
    // 复制并查询
    copyTextToQuery (vpresId) {
      this.vpresId = vpresId;
      this.nodeQueryVisible = true;
    },
    getTagList () {
      ApiMethods.UserTagController.getAllUserTagList().then(res => {
        if (!res.success && this.$store.getters.authUser.identityAuth > -1)
          return this.$message.error(res.description || this.$tip);
        if ((res.data || []).length === 0 && !this.getDTag)
          return this.getDefaultTag();
        this.tagLists = res.data;
      });
    },
    getDefaultTag () {
      this.getDTag = true;
      ApiMethods.UserTagController.getDefaultTag().then(res => {
        if (!res.success && this.$store.getters.authUser.identityAuth > -1)
          return this.$message.error(res.description || this.$tip);
        this.getTagList();
      });
    },
    setTag (tag, row) {
      this.$refs.tagManage.setTag(tag, row, 0).then(res => {
        if (!res.success)
          return this.$message.error(res.description || "操作失败");
        this.$set(row, "tag", []);
        tag && row.tag.push(tag);
      });
    },
    cellMouseEnter (row) {
      this.$set(row, "showTag", true);
    },
    cellMouseLeave (row) {
      row.showTag = false;
    },
    showTagManage () {
      this.$refs.tagManage.setVisible(true);
    },
    resetScreenParams () {
      this.selectParam = "contractName";
      this.selectedStatus = "";
      this.selectParamVal = "";
      this.queryParam = {
        itemPage: 1,
        pageSize: 10,
        total: 0,
        dateType: null,
        beginDate: null,
        endDate: null,
        applyNo: null,
        contractName: null,
        signatoryFullName: null,
        signatoryMobile: null,
        signatoryIdentityCard: null,
        signStatusSet: null,
        createType: 1,
        newVersion: 1,
        showAll: 1
      };
      this.paramDataArr = null;
      this.signStatus = this.$route.query ? (+this.$route.query.signStatus) : 1;
      this.directoryId = (this.$route.query && this.$route.query.directoryId) ? (+this.$route.query.directoryId) : '';
    },
    // 批量发起合同生成检查
    checkContractBatch () {
      /*let query = this.$route.query
        let snapshotId = undefined
        if (localStorage.getItem('snapshotId')) {
          snapshotId = parseInt(localStorage.getItem('snapshotId'))
          let params = {}
          params.snapshotId = snapshotId
          this.batchLoading = true
          // 个人
          if (query.orderNumber) {
            params.orderNo = query.orderNumber
            this.findOrderInterval(params)
          } else {
            // 集团
            this.findOrderIntervalCorp(params)
          }
        }*/
      let query = this.$route.query;
      if (query.snapshotId) {
        let params = {
          snapshotId: query.snapshotId,
          orderNo: query.orderNumber || null
        };

        this.batchLoading = true;
        this.findOrderInterval(params);
      }
    },
    // 批量发起普通用户
    findOrderInterval (params) {
      ApiCorpMethods.BatchContractController.findOrder(params)
        .then(res => {
          if (res.code === "0") {
            if (res.data.success > 0) {
              this.batchLoading = false;
              this.$alert(`成功发起${res.data.success}份`, "", {
                confirmButtonText: "确定",
                callback: action => {
                  const query = Object.assign({}, this.$route.query);
                  delete query.snapshotId;
                  this.$router.push({ path: this.$route.path, query: query });
                  this.queryFilter();
                }
              });
            } else {
              setTimeout(() => {
                this.findOrderInterval(params);
              }, 2000);
            }
          } else {
            this.batchLoading = false;
            this.$message.error(
              res.description || "批量发起失败，请刷新后再试"
            );
          }
        })
        .catch(err => {
          this.batchLoading = false;
          this.$message.error(err.description || "批量发起失败，请刷新后再试");
        });
    },
    // 重置
    rest () {
      this.selectParam = "contractName";
      this.selectParamVal = "";
      this.selectedStatus = "";
      this.selectParamVal = ''
      this.paramDateArr = null;
      // this.signStatusSetFn()

      this.resetScreenParams()
      this.queryParam.itemPage = 1;
      this.queryParam.pageSize = 10;
      this.signStatusFn(this.signStatus);
    },
    // 查询 筛选
    queryFilter: function () {
      this.queryParam.itemPage = 1;
      this.queryParam.pageSize = 10;
      this.getSignLists();
    },
    //追加条件
    addConditionFn () {
      if (this.signStatus === 2) {
        // this.queryParam["selfSign"] = 0;
      } else if (this.signStatus === 3) {
        this.queryParam["signStatusSet"] = '1,2,4,-5,-6';
      }
    },
    // 获取合同列表
    getSignLists: function () {
      this.loading = true;
      this.batchLength = null;
      this.$emit("batchLength", this.batchLength);
      let newPar = {
        ...this.queryParam
      };
      newPar.excludeSelfSign = 1;
      postApplyPage(newPar)
        .then(data => {
          this.queryParam.itemPage = data.pageNum;
          this.queryParam.pageSize = data.pageSize;
          this.queryParam.total = data.total;
          this.tableList = data.data;
          if (window.location.href.indexOf("match") > -1) {
            this.getApplyBadge();
          } else {
            this.badge = data.total;
            this.$emit("update:badge", data.total);
          }
        })
        .catch(e => { })
        .finally(() => {
          this.loading = false;
        });
    },
    getApplyBadge: function () {
      postApplyBadge(this.queryParam).then(data => {
        this.badge = data.data;
        this.$emit("update:badge", data.data);
      });
    },
    handleSizeChange (val) {
      this.queryParam.itemPage = 1;
      this.queryParam.pageSize = val;
      this.getSignLists();
    },
    handleCurrentChange (val) {
      this.queryParam.itemPage = val;
      this.getSignLists();
    },
    filterTag: function (row, column) {
      return row === column.status;
    },
    handleSelectionChange: function (val) {
      this.checkedList = val;
      this.batchLength = val.length;
      this.$emit("batchLength", this.batchLength);
    },
    to: function (url, target) {
      window.open(url, target);
    },

    //履约文件相关 882需求新增
    openLYDialog (rowData) {
      this.lYDialogVisible = true;
      this.rowData = rowData;
      this.setLYDialogData();
    },
    //展示履约文件弹窗
    async setLYDialogData () {
      let _this = this;
      let param = {
        uploadType: this.activeName,
        applyNo: this.rowData.applyNo || ""
      };
      let res = await ApiMethods.PerformanceController.getList(param);
      if (res.success) {
        this.lYDialogData = res.data;
      } else {
        _this.$message.error(res.description);
      }
    },
    // 获取附件后缀
    getEnclosureSuffix (item) {
      if (item.fileName) {
        let arr = item.fileName.split(".");
        return arr[arr.length - 1];
      }
      return "";
    },
    // 附件是否文档
    isDoc (item) {
      let str = this.getEnclosureSuffix(item).toLocaleUpperCase();
      // let arr = ['DOCX','DOC','PDF','XLS','XLSX']
      let arr = ["PDF"];
      if (arr.indexOf(str) > -1) {
        return true;
      }
      return false;
    },
    // 附件是否图片或视频
    isVideoOrImg (item) {
      let str = this.getEnclosureSuffix(item).toLocaleUpperCase();
      // let arr = ['DOCX','DOC','PDF','XLS','XLSX']
      let arr = ["PNG", "GIF", "JPG", "JPEG", "MP4", "WEBM", "OGG"];
      if (arr.indexOf(str) > -1) {
        return true;
      }
      return false;
    },
    // 预览履约文件图片或者视频
    previewVideOrImg (item) {
      this.enclosurePreviewNumItem = item;
      this.visibleShowEnclosure = true;
      // 刷新预览弹窗，更新
      this.isRefresh = false;
      this.$nextTick(() => {
        this.isRefresh = true;
      });
    },
    // 预览履约文件文档
    previewDoc (item) {
      this.enclosurePreviewNumItem = item;
      this.visibleShowEnclosureDoc = true;
    },

    //删除履约文件
    delLYFile (item) {
      this.$confirm("该操作删除后的文件将无法恢复，确认删除？", "系统提示", {
        showCancelButton: true,
        showCancelButton: true,
        type: "info"
      })
        .then(() => {
          ApiMethods.PerformanceController.del({
            performanceId: item.performanceId
          })
            .then(data => {
              if (data.success) {
                this.setLYDialogData();
              } else {
                _this.$message.error(data.description);
              }
            })
            .catch(err => {
              this.$message.error(
                err.description || "删除失败，请刷新后再试！"
              );
            });
        })
        .catch(() => { });
    },
    //下载履约文件
    downloadLYFile (item) {
      if (!item || item === "null" || item === "false")
        return "javascript:void(0)";
      if (item.fileName === "blob") {
        item.fileName = "attachment.png";
        item.fix = ".png";
      }
      return getFindFileDownload(item);
    },
    // 执行预览图片视频关闭后参数回传
    onSetViewFilesToImgDialogData (data) {
      this.visibleShowEnclosure = data.visibleShow;
      this.enclosurePreviewNumItem = data.obj;
    },
    // 执行预览PDF关闭后参数回传
    onSetViewFilesToDocDialogData (data) {
      this.visibleShowEnclosureDoc = data.visibleShow;
      this.enclosurePreviewNumItem = data.obj;
    },
    // 上传履约文件
    handleInputChange: function (e) {
      e = e.target;
      let param = { file: e.files[0] };
      if (!param.file) return;
      var frm = new FormData();
      if (+this.activeName == 1) {
        if (param.file.size > 30 * 1024 * 1024) {
          e.value = "";
          param = { file: "" };

          return this.$confirm(`上传的签章文件不能超过30M`, "系统提示", {
            showCancelButton: false,
            confirmButtonText: "确定",
            type: "warning"
          })
            .then(() => { })
            .catch(() => { });
        }
        frm.append("file", param.file);
        frm.append("fileName", e.files[0].name);
        frm.append("uploadType", this.activeName);
        frm.append("applyNo", this.rowData.applyNo);
        ApiMethods.PerformanceController.upload(frm)
          .then(res => {
            this.$refs.referenceUpload.value = null;
            if (res.success) {
              this.$message.success("上传成功");
              this.setLYDialogData();
            } else {
              this.$message.error(res.description);
            }
          })
          .catch(e => {
            this.$message.error(e.description);
          });
      } else {
        if (param.file.size > 500 * 1024 * 1024) {
          e.value = "";
          param = { file: "" };

          return this.$confirm(`上传的签章文件不能超过500M`, "系统提示", {
            showCancelButton: false,
            confirmButtonText: "确定",
            type: "warning"
          })
            .then(() => { })
            .catch(() => { });
        }
        let _this = this;
        let targetFileHash = "";
        const sha512 = sha512Crypto.create();
        _this.fileSliceDeal(
          e.files[0],
          1024 * 1024 * 2,
          function (fileSlice) {
            sha512.update(fileSlice);
          },
          function () {
            targetFileHash = sha512.hex();
            frm.append("hashValue", targetFileHash);
            frm.append("fileName", e.files[0].name);
            frm.append("uploadType", _this.activeName);
            frm.append("applyNo", _this.rowData.applyNo);
            ApiMethods.PerformanceController.upload(frm)
              .then(res => {
                _this.$refs.referenceUpload1.value = null;
                if (res.success) {
                  _this.$message.success("上传成功");
                  _this.setLYDialogData();
                } else {
                  _this.$message.error(res.description);
                }
              })
              .catch(e => {
                _this.$message.error(e.description);
              });
          }
        );
      }
    },

    handleClick (tab) {
      this.activeName = tab.name;
      this.setLYDialogData();
    },
    validLYFile (item) {
      const url = "https://www.ebaoquan.org/query?type=2&bah=" + item.presId
      isInDingTalk ? location.href = url : window.open(url, "_blank");
      // window.open(
      //   "http://sandbox.ebaoquan.org/query?type=2&bah=" + item.presId,
      //   "_blank"
      // );
    },
    fileSliceDeal: function (file, sliceSize, dealFun, finishFun) {
      var startTime = new Date().getTime();
      var chunkSize = file.size;
      var chunks = 1;
      var blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice;
      if (blobSlice) {
        chunkSize = sliceSize;
        chunks = Math.ceil(file.size / chunkSize);
      }
      var currentChunk = 0;
      var fileReader = new FileReader();
      fileReader.onload = function (e) {
        dealFun(e.target.result, currentChunk, chunks);
        currentChunk++;
        if (currentChunk < chunks) {
          loadNext();
        } else {
          finishFun();
          //            console.log('finished');
          //            console.log(new Date().getTime() - startTime)
        }
      };
      fileReader.onerror = function () {
        console.warn("oops, something went wrong.");
      };
      function loadNext () {
        var start = currentChunk * chunkSize;
        var end =
          start + chunkSize >= file.size ? file.size : start + chunkSize;
        fileReader.readAsArrayBuffer(
          blobSlice ? blobSlice.call(file, start, end) : file
        );
      }
      loadNext();
    }
  },
  name: "applyList"
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__title {
  padding: 10px;
}
/deep/ .el-table__expand-icon {
  display: none !important;
}
.hover-win {
  padding: 5px;

  .icontag:hover {
    background: whitesmoke;
  }
}

.icontag {
  color: #ddd;
}

.nosign-url {
  font-size: 12px;
  color: #666666;
  margin-bottom: 20px;
}

.query-label {
  font-weight: 600;
  white-space: nowrap;
}
.multiFile {
  position: absolute;
  font-size: 12px;
  top: 0px;
  left: -12px;
  width: 22px;
  height: 16px;
  line-height: 16px;
  background-color: #eb090a;
  color: #ffffff;
  text-align: center;
  border-radius: 4px;
  transform: scale(0.8);
  z-index: 2;
  &:after {
    content: "";
    position: absolute;
    bottom: -4px;
    right: 4px;
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-right: 5px solid #eb090a;
    z-index: 1;
  }
}
.textEllipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #290202;
  opacity: 0.65;
}
.edit {
  color: #290202;
  font-weight: bold;

  &:hover {
    color: #ec1c1c;
  }
}
.bulkOperation {
  width: 85%;
  height: 50px;
  background: #f9f9f9;
  position: absolute;
  top: 99px;
  left: 140px;
  display: flex;
  align-items: center;
  color: rgba(41, 2, 2, 0.45);
}

.apply-list {
  max-width: 1200px;
  margin: 0 auto;
}

.pageation {
  //margin-left: 80px;
  padding: 30px 10px 20px 10px;
  border-top: 0;
}

.dialog-footer {
  padding-bottom: 20px;

  .btn {
    width: 30%;
  }
}

nav.nav-bar {
  width: 100%;
  margin-top: 20px;
  border: 1px dashed #d7d7d7;
  overflow: hidden;

  li.nav-item {
    margin-right: 14px;
    padding: 10px 15px;
    color: #666;
    border: none;
    background: #fff;
    cursor: pointer;
  }

  .nav-item.active {
    color: #ec1c1c;
  }

  ul.nav {
    width: 100%;
  }
}

.color-success {
  cursor: pointer;
}

.custom-link {
  cursor: pointer;
  color: rgba(41, 2, 2, 1);
  font-weight: 800;
}

.custom-link:hover {
  color: #ec1c1c;
  text-decoration: underline;
}
.ly-mask {
  .tips {
    color: rgb(115, 90, 90);
    font-size: 12px;
    text-align: left;
  }

  .box-wrap {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-left: -20px;
    margin-top: -15px;
    padding: 15px;
    &:last-child {
      /* margin-bottom: 130px; */
    }
    .temone {
      position: relative;
      margin-left: 20px;
      margin-top: 15px;
      width: 175px;
      text-align: center;
      border: 1px solid rgba(238, 238, 238, 1);
      border-radius: 4px;
      &.add {
        cursor: pointer;
        height: 140px;
        line-height: 140px;
        display: flex;
        justify-content: center;
        align-items: center;
        .file-ipt {
          width: inherit;
          height: inherit;
          position: absolute;
          opacity: 0;
        }
        &:hover {
          box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.28);
        }
      }
      &.temone-center {
        height: 140px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .t-box {
          width: 100%;
          height: 75%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          .y-img {
            margin-top: 0;
          }
        }
        .tpid {
          width: 100%;
          height: 25%;
          background: #eeeeee;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      &:hover {
        .t-box {
          .msk {
            width: 100%;
            height: 100%;
            opacity: 1;
          }
        }

        .has-hover {
          display: block;
        }
        .no-hover {
          display: none;
        }
      }
      .t-box {
        position: relative;
        height: 105px;
        overflow: hidden;

        .y-img {
          width: 46px;
          height: 54px;
          display: block;
          margin: 17px auto 7px auto;
        }
        p {
          font-size: 14px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding: 0 10px;
          width: 100%;
          font-family: Source Han Sans SC;
          color: rgba(41, 2, 2, 0.65);
          box-sizing: border-box;
        }
        .msk {
          transition: all ease 0.2s;
          position: absolute;
          left: 0;
          top: 0;
          width: 0;
          height: 0;
          background: rgba(0, 0, 0, 0.5);
          opacity: 0;
          padding: 8px 8px;
          box-sizing: border-box;
          .des {
            margin-top: 20px;
            font-size: 12px;
            text-align: left;
          }
          p {
            color: rgba(41, 2, 2, 0.65);
          }
          span {
            cursor: pointer;
            color: #ffffff;
            margin-left: 10px;
          }
        }
      }

      .b-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        a {
          width: 50%;
        }
      }
      .el-icon-plus {
        cursor: pointer;
        color: #c9bfbf;
        font-size: 80px;
      }
    }
  }
  .a-btn {
    cursor: pointer;
    display: flex;
    justify-content: space-evenly;
    width: 100%;
    height: 35px;
    line-height: 35px;
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: rgba(41, 2, 2, 1);
    text-decoration: none;
    border-radius: 0px 0px 4px 4px;
    background: rgba(239, 239, 239, 1);
    a {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      &:hover {
        color: rgba(236, 28, 28, 1);
      }
    }
    .has-hover {
      display: none;
    }
    .no-hover {
      display: block;
    }
  }
}

/deep/.ly-info .el-tabs__item.is-active {
  color: rgb(236, 28, 28);
}

/deep/.ly-info .el-tabs__active-bar {
  background-color: rgb(236, 28, 28);
}

/deep/.ly-info .el-tabs__item {
  color: rgb(158, 140, 140);
}
.footer {
  height: 50px;
  position: relative;
  .num {
    margin-left: 20px;
    font-size: 14px;
    color: rgb(140, 140, 140);
    label {
      color: #ec1c1c;
    }
  }
  .cancel-btn {
    position: absolute;
    right: 20px;
  }
}
/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #ffffff;
}
/deep/ .el-dialog__header {
  border-radius: 11px;
  padding: 0 !important;
}
.node_header {
  height: 50px;
  line-height: 50px;
  text-align: center;
  background-color: #ed4031;
  background-size: 100%;
  font-size: 16px;
  color: #ffffff;
}
/deep/.ly-info .el-dialog__body {
  height: 420px;
  overflow-y: auto;
}
/deep/.ly-info .el-dialog__footer {
  text-align: left;
}
</style>
<style lang="less">
.el-popper .popper__arrow::after {
  border-bottom-color: #f5f6f6 !important;
}
.data-dialog {
  padding: 0;
  border-radius: 11px;
}
/*.el-dialog__body {*/
/*  padding: 0;*/
/*}*/
.el-dialog__headerbtn .el-dialog__close {
  color: #01040a;
}
</style>



// WEBPACK FOOTER //
// pages/signInfo/applyListNew.vue